import debounce from 'lodash.debounce';
import { h } from 'preact';
import { useCallback, useState } from 'preact/hooks';
import { InputHTMLAttributes } from 'react';

import styled from 'styled-components';
import { Typography } from '../../util/Typography';

type AutoCompleteProps = InputHTMLAttributes<HTMLInputElement> & {
	placeHolder: string;
	requests: Function;
	options: any[];
	keyValue: string;
	onClickFunction: Function;
	showResults: boolean;
	defaultLabelValue: string;
}

const InputText = styled.input`
	width: 100%;
	outline: 0;
	border-width: 0 0 1px;
	border-color: black;
	height: 30px;
	font-family: 'Nunito Sans';
	font-size: 16px;
	font-style: normal;
	letter-spacing: 0.01px;
	font-weight: bold;
	line-height: 34px;
	padding-bottom: 0px;
	::placeholder {
		font-family: 'Nunito Sans';
		font-size: 16px;
		font-weight: normal;
		line-height: 34px;
		letter-spacing: 0.01em;
	}
`;

const AutocompleteWrapper = styled.div`
	position: relative;
`;

export const AutoCompleteItem = styled.li`
	padding: 0 24px;
	width: 100%;
	box-sizing: border-box;
	&:hover {
		background-color: #ebf4ff;
	}
`;

export const AutoCompleteItemButton = styled.button`
	width: 100%;
	line-height: 32px;
	text-align: left;
	border: none;
	padding: 0;
	background: none;
	outline: none;
	&:active {
		outline: none;
	}
`;

export const AutoCompleteContainer = styled.ul`
	width: 99%;
	background-color: white;
	position: absolute;
	padding: 8px 0;
	margin-top: 1px;
	list-style-type: none;
	box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
	z-index: 5;
`;

export const AutoComplete = ({
	placeHolder,
	requests,
	options,
	keyValue,
	showResults,
	onClickFunction,
	defaultLabelValue,
	...props
}: AutoCompleteProps) => {
	const [inputValue, setInputValue] = useState(defaultLabelValue);

	const debouncedSave = useCallback(
		debounce((newValue: any) => requests(newValue), 1000),
		[],
	);

	const updateValue = (newValue: any) => {
		setInputValue(newValue);
		debouncedSave(newValue);
	};

	const onSelected = (item: any) => {
		setInputValue(item.labelValue);
		onClickFunction(item);
	};

	return (
		<AutocompleteWrapper>
			<InputText
				onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
				onChange={(input) => updateValue(input.target.value)}
				{...props}
				placeholder={placeHolder}
				type="text"
				value={inputValue}
			/>
			{showResults && options.length > 0 && (
				<AutoCompleteContainer>
					{options?.map((item: any) => (
						<AutoCompleteItem key={item[keyValue]}>
							<AutoCompleteItemButton key={item[keyValue]} onClick={() => onSelected(item)}>
								<Typography variant="body2">{item.labelValue}</Typography>
							</AutoCompleteItemButton>
						</AutoCompleteItem>
					))}
				</AutoCompleteContainer>
			)}
		</AutocompleteWrapper>
	);
};
